<template>
<div>
  <div v-if="jobseekers.length > 0 ">
      <columns :is-multiline="true">
        <column size="is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd" v-for="(user) in jobseekers" :key="user.id">
          <user-card :user="user" :cardClick="onCardClicked" :notWidget="true" ></user-card>
        </column>
      </columns>
  </div>
  <empty-state v-else title="No Jobseekers" icon="empty-state-eyes" >
    <template slot="content">
      <p class="text">No jobseekers to show here. Try changing your selected state or search selection. Know somebody that would benefit from HireVibes? Invite them!</p>
    </template>
  </empty-state>
</div>
</template>

<script>
import { mapState } from 'vuex'
import RowCard from '@/components/general/row-card'
import EmptyState from '@/components/general/empty-state'
import UserCard from '../general/user-card'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'

export default {
  components: { RowCard, EmptyState, Column, Columns, UserCard },
  computed: {
    ...mapState('jobseekers', [
      'jobseekers'
    ])
  },
  methods: {
    name (user) {
      return `${user.firstName} ${user.lastName}`
    },
    imageUrl (user) {
      return user.profilePictureUrl || `/api/identicons/${user.id}`
    },
    locations (user) {
      return user.location
    },
    role (user) {
      return user.role
    },
    company (user) {
      return user.companyName
    },
    onCardClicked (user) {
      this.$router.push({path: `/jobseekers/${user.id}`})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.card.jobseeker-card {
  cursor: pointer;
}

.card.jobseeker-card:hover {
  background-color: $hover-background;
}

.card.jobseeker-card:not(:first-child) {
  border-top: 0;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.card.jobseeker-card:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/jobseekers-list.vue